import React from 'react';
import '../../../assets/css/style.css';
import RadioChipContainer from '../elements/RadioChipContainer';

const VirtuesSmoke = () => {
    const intakeNames = ['Socially','Regularly','Never','Prefer Not to Say'];

    return (
        <div className="chip-container">
            <RadioChipContainer labels={intakeNames} type="smoking" />
        </div>
    );
};

export default VirtuesSmoke;